var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiagnosis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140.967,
    height: 155.057,
    viewBox: "0 0 140.967 155.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 140.967,
    height: 155.057,
    fill: "#c4e7f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diagnosis",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M34.888,91.121a9.338,9.338,0,1,0,17.441-6.678L29.783,25.508l2.11-1.414L24.806,5.586,2.532,14.11l7.11,18.583L12.4,32.33ZM32.634,49.03l-6.709,2.564L17.538,29.675,24.247,27.1Z",
    transform: "translate(16.619 36.665)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M79.548,1.516,74.776,3.362l3.146,8.146,4.773-1.845c5.7-2.209,12,.272,14.023,5.521l34.89,90.216c2.027,5.257-.961,11.322-6.663,13.523L58.28,144.7c-5.71,2.209-12-.272-14.03-5.521L9.367,48.961c-2.035-5.257.953-11.322,6.663-13.523L19.3,34.175l-3.146-8.146-3.275,1.263C2.689,31.233-2.545,42.366,1.222,52.108l34.89,90.216c3.767,9.742,15.119,14.461,25.315,10.521l66.664-25.776c10.2-3.941,15.422-15.074,11.655-24.816L104.863,12.037C101.1,2.3,89.736-2.424,79.548,1.516",
    transform: "translate(-0.004 0.823)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M41.308,5.64,35.583,7.848A12.273,12.273,0,0,0,12.688,16.7L6.963,18.913a6.137,6.137,0,0,0-3.509,7.934l3.32,8.584a3.07,3.07,0,0,0,3.971,1.755L50.808,21.7a3.075,3.075,0,0,0,1.762-3.963L49.242,9.149A6.134,6.134,0,0,0,41.308,5.64M26.348,18a6.135,6.135,0,1,1,3.509-7.934A6.128,6.128,0,0,1,26.348,18",
    transform: "translate(19.955 0.005)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M20.23,19.74A8.45,8.45,0,1,0,9.316,14.876,8.449,8.449,0,0,0,20.23,19.74",
    transform: "translate(57.446 22.315)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M61.274,74.5,39.121,16.823a1.011,1.011,0,0,1,1.891-.719L51.139,42.478a3.346,3.346,0,0,0,6.247-2.4L45.361,8.783S44.469,5.41,38.176,5.44c-6.013.03-13.841,3.124-13.985,3.184,0,0-8.01,2.957-12.54,7-4.7,4.19-3.109,7.291-3.109,7.291l12,31.3a3.346,3.346,0,0,0,6.247-2.4L16.665,25.445a1.013,1.013,0,1,1,1.891-.726L40.694,82.4a4.423,4.423,0,0,0,8.259-3.169L36.671,47.22a7.684,7.684,0,0,1,1.876-1.112,7.481,7.481,0,0,1,2.178-.439L53.015,77.678A4.425,4.425,0,0,0,61.274,74.5M32.307,43.386a4.111,4.111,0,1,1,4.107-4.114,4.12,4.12,0,0,1-4.107,4.114",
    transform: "translate(54.37 35.707)",
    fill: "#c4e7f8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosis);
export default __webpack_public_path__ + "static/media/diagnosis.f63b2af14fa1d8f6a167485fe1a6d252.svg";
export { ForwardRef as ReactComponent };